class ScriptLoader {

	constructor () {
		this.loadedAssets = [];
	}

	//get browser base url
	getBaseurl () {
		let loc = location;
		return loc.origin || loc.protocol + '//' + loc.hostname + (loc.port ? ':' + loc.port : '');
	}

    /**
     * @desc check url is injected to the DOM
     * @param url
     * @returns {undefined or bool}
     */
	getLoadedAssets (url) {
		return this.loadedAssets[url];
	}

    /**
     * @desc push styles or scripts into this.loadedAssets array and set its value to be boolean value
     *       to indicate the files are loaded.
     * @param url
     * @param v
     */
	setLoadedAssets (url, v) {
		this.loadedAssets[url] = v;
	}

    /**
     * inject the styles in the head
     * @param url
     */
	getStyles (url) {

        //check if the file is loaded
		let isFileLoaded = this.getLoadedAssets( url );

        //if it is yes, return to the caller
		if( isFileLoaded === true) {
			return;
		}

		let head = document.head,
			link = document.createElement('link');

		link.type = 'text/css';
		link.rel = 'stylesheet';
		link.href = url;

		head.appendChild(link);

        /**
         * call this.setLoadedAssets to set url in this.loadedAssets
         * to be true, indicating the file is loaded.
         */
		this.setLoadedAssets(url, true);
	}

	/**
	 * @desc inject scripts into DOM dynamically with sync or async and execute a callback after script is loaded
	 * @param string url
	 * @param function callback
	 * @param bool async - true or false
	 * @return undefined
	 */
	getScript (url, callback, async) {

		// Create a new script and setup the basics.
		let script = document.createElement("script");
		let	firstScript = document.getElementsByTagName('script')[0];

		//if the third argument is passed, load the script asynchronously; otherwise load it synchronously
		if(async === undefined && async !== false) {
			script.async = true;
		} else {
			script.async = false;
		}

		script.src = url;
		// Handle the case where an optional callback was passed in.
		if ("function" === typeof(callback)) {
			script.onload = function() {

				callback();
				// Clear it out to avoid getting called more than once or any memory leaks.
				script.onload = script.onreadystatechange = undefined;
			};

			script.onreadystatechange = function() {
				if ("loaded" === script.readyState || "complete" === script.readyState) {
					script.onload();
				}
			};
		}

		//Attach the script tag to the page (before the first script) so the magic can happen.
        firstScript.parentNode.insertBefore(script, firstScript);

	}

}

export default new ScriptLoader();





// WEBPACK FOOTER //
// ./assets/components/fsUtils/ScriptLoader.js